<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{ $t('text.generate_report') }}</span>
    </div>
    <div class="page-card-content pt-20">
      <div class="page-content max-w-742">
        <el-form :model="form" :rules="rules" ref="form" label-width="150px">
          <el-form-item :label="$t('text.facility')" prop="buildingId">
            <el-select
              v-model="form.buildingId"
              :placeholder="$t('text.select')"
              class="wp-100"
            >
              <el-option
                v-for="item in buildingOptions"
                :key="item.BuildingId"
                :label="item.BuildingName"
                :value="item.BuildingId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('text.period') + ' 1 (' + $t('text.baseline') + ')'"
            prop="date1"
          >
            <el-date-picker
              class="w-full"
              v-model="form.date1"
              type="datetimerange"
              format="dd/MM/yy h:mm:ss A"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="to"
              :start-placeholder="$t('text.start_time')"
              :end-placeholder="$t('text.end_time')"
              :unlink-panels="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            :label="$t('text.period') + ' 2 (' + $t('text.trial') + ')'"
            prop="date2"
          >
            <el-date-picker
              class="w-full"
              v-model="form.date2"
              type="datetimerange"
              format="dd/MM/yy h:mm:ss A"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="to"
              :start-placeholder="$t('text.start_time')"
              :end-placeholder="$t('text.end_time')"
              :unlink-panels="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              class="common-btn"
              :loading="loading"
              @click="submit()"
              >{{ $t('text.generate_report') }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import moment from 'moment'
export default {
  data() {
    var checkTimeSpanForDate1 = (rule, value, callback) => {
      if (this.form.date1.length === 2 && this.form.date2.length === 2) {
        this.$refs.form.validateField('date2')
      }
      callback()
    }
    var checkTimeSpanForDate2 = (rule, value, callback) => {
      if (this.form.date1.length === 2 && this.form.date2.length === 2) {
        let timeSpan1 = moment(this.form.date1[1]).diff(
          moment(this.form.date1[0]),
          'hours'
        )
        let timeSpan2 = moment(this.form.date2[1]).diff(
          moment(this.form.date2[0]),
          'hours'
        )
        if (timeSpan1 !== timeSpan2) {
          callback(
            new Error(this.$t('text.time_period_inconsistent_warning') + '!')
          )
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      loading: false,
      form: {
        buildingId: '',
        date1: [
          moment().format('YYYY-MM-DD 00:00:00'),
          moment()
            .add(1, 'days')
            .format('YYYY-MM-DD 00:00:00')
        ],
        date2: [
          moment().format('YYYY-MM-DD 00:00:00'),
          moment()
            .add(1, 'days')
            .format('YYYY-MM-DD 00:00:00')
        ]
      },
      rules: {
        buildingId: [
          {
            required: true,
            message: this.$t('text.please_select_facility'),
            trigger: 'change'
          }
        ],
        date1: [
          {
            required: true,
            message: this.$t('text.please_select'),
            trigger: 'change'
          },
          {
            validator: checkTimeSpanForDate1,
            trigger: 'change'
          }
        ],
        date2: [
          {
            required: true,
            message: this.$t('text.please_select'),
            trigger: 'change'
          },
          {
            validator: checkTimeSpanForDate2,
            trigger: 'change'
          }
        ]
      },
      buildingOptions: []
    }
  },
  mounted: function() {
    this.getBuildings()
  },
  methods: {
    getBuildings() {
      this.$store.dispatch('filter/getBuildings').then(() => {
        this.buildingOptions = this.$store.state.filter.buildings
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.handleGenerate()
        }
      })
    },
    getParams() {
      return {
        organisationId: this.$store.getters[`user/selecteOrganisationId`],
        fromDate1: this.form.date1[0],
        toDate1: this.form.date1[1],
        fromDate2: this.form.date2[0],
        toDate2: this.form.date2[1],
        buildingId: this.form.buildingId
      }
    },
    handleGenerate() {
      this.loading = true
      ApiService.CreateOrganisationReport(this.getParams())
        .then(response => {
          this.loading = false
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.generate_in_progress'),
              text: this.$t('text.generate_desc')
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>
